/* eslint no-console:0 */
/* global Turbo */
// JS half of the former `application` Webpacker pack. The CSS it used to
// import lives in the sibling `application.css` entrypoint (Webpacker ran
// with extract_css: true, so styles were delivered via stylesheet_pack_tag,
// not this bundle).
import "@hotwired/turbo-rails";
import "../controllers";

/*
  Make Turbo Drive opt-in by default
  Add data-turbo="true" to enable Drive on a per-element basis.
  https://turbo.hotwired.dev/handbook/drive#disabling-turbo-drive-on-specific-links-or-forms
*/
Turbo.session.drive = false;

/*
 * Override turbo-confirm to display a custom dialog
 */
Turbo.setConfirmMethod((message) => {
  const dialog = document.getElementById("turbo-confirm");
  // application.js loads on layouts that don't render the #turbo-confirm
  // partial; treat a missing dialog as a cancellation rather than throwing.
  if (!dialog) return Promise.resolve(false);
  dialog.querySelector("p").textContent = message;
  dialog.showModal();

  return new Promise((resolve) => {
    dialog.addEventListener("close", () => {
      resolve(dialog.returnValue === "confirm");
    }, { once: true });
  });
});
